// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-1qprcsu-option{
    text-align: left;
}
.css-1vr111p-option{
    text-align: left;
}
.css-1r4vtzz{
    width: 100% !important;
}
.css-48ayfv{
    width: 100% !important;
}

input{
    height: inherit
}

.react-select__option{
    font-size: 80% !important;
}

.react-select__option1{
    font-size: 100% !important;
}

.react-select__menu-list{
    max-height: 150px !important;
    -webkit-overflow-scrolling:auto !important;
}
.ev_filter_icon {
    background: #fff !important;
    color: #348393 !important;
}
.ev_filter_icon:hover {
    background: #348393 !important;
    color: #fff !important;
}
.card.align-items-center.lp_br_bus {
    border: 1px solid lightgray;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard/Driveanalysis/CustomeSelect.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,0CAA0C;AAC9C;AACA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;AACA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;AACA;IACI,2BAA2B;AAC/B","sourcesContent":[".css-1qprcsu-option{\r\n    text-align: left;\r\n}\r\n.css-1vr111p-option{\r\n    text-align: left;\r\n}\r\n.css-1r4vtzz{\r\n    width: 100% !important;\r\n}\r\n.css-48ayfv{\r\n    width: 100% !important;\r\n}\r\n\r\ninput{\r\n    height: inherit\r\n}\r\n\r\n.react-select__option{\r\n    font-size: 80% !important;\r\n}\r\n\r\n.react-select__option1{\r\n    font-size: 100% !important;\r\n}\r\n\r\n.react-select__menu-list{\r\n    max-height: 150px !important;\r\n    -webkit-overflow-scrolling:auto !important;\r\n}\r\n.ev_filter_icon {\r\n    background: #fff !important;\r\n    color: #348393 !important;\r\n}\r\n.ev_filter_icon:hover {\r\n    background: #348393 !important;\r\n    color: #fff !important;\r\n}\r\n.card.align-items-center.lp_br_bus {\r\n    border: 1px solid lightgray;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
